import { Checkbox } from '@/components/ui/checkbox';
import { FormControl } from '@/components/ui/form';
import { sortBySortOrder } from '@/utils/sort';
import type { SurveyQuestionDetail } from '../../types/survey.types';
import { AnswerOptionRow } from './AnswerOptionRow';

interface CheckboxAnswerInputProps {
  name: string;
  options: SurveyQuestionDetail['options'];
  value: string[];
  onChange: (value: string[]) => void;
  invalid: boolean;
}

export function CheckboxAnswerInput({
  name,
  options,
  value,
  onChange,
  invalid,
}: CheckboxAnswerInputProps) {
  const sortedOptions = sortBySortOrder(options);

  function toggleOption(optionId: string, checked: boolean) {
    if (checked) {
      onChange([...value, optionId]);
    } else {
      onChange(value.filter((id) => id !== optionId));
    }
  }

  return (
    <div className="space-y-2" aria-invalid={invalid || undefined}>
      {sortedOptions.map((option) => {
        const optionId = `${name}-option-${option.id}`;
        const optionValue = String(option.id);
        return (
          <AnswerOptionRow key={option.id} optionId={optionId} label={option.text}>
            <FormControl>
              <Checkbox
                id={optionId}
                checked={value.includes(optionValue)}
                onCheckedChange={(checked) => toggleOption(optionValue, checked === true)}
              />
            </FormControl>
          </AnswerOptionRow>
        );
      })}
    </div>
  );
}
